import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

export const getSystemPOsWithStoppedInvoices = async () => {
  try {
    const response = await apiClient.get(
      '/systemInvoiceManagement/workflow/pos-with-stopped-invoices'
    );
    if (response.data?.response && Array.isArray(response.data.response)) {
      return response.data.response;
    }
    return response.data?.response || response.data || [];
  } catch (error) {
    handleApiError(error);
  }
};
